import React, { PureComponent, Fragment } from "react";
import Pagination from "react-js-pagination";
import { AJAX_REQUEST, APP_URL, sentryErrorLog } from "../../Constants/AppConstants";
import * as RBT from "react-bootstrap";
import * as faIcon from "@fortawesome/free-solid-svg-icons";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from "moment";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { setReloadReply } from '../../Store/actions/loginActions';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Scrollbars } from "react-custom-scrollbars";
import PaginationLeftButton from "../Common/PaginationLeftButton";
import PaginationRightButton from "../Common/PaginationRightButton";
import Select from 'react-select';

class ContactList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mounted: true,
      loading: true,
      activePage: 1,
      itemsCountPerPage: 0,
      totalItemsCount: 0,
      latest_replies: [],
      loadLatestReply: 1,
      option_true: false,
      activeTab: "stats",

      query: "",
      pageNumber: 1,
      daterange: [new Date(moment().subtract(30, "days")), new Date()],
      Options: [],
      follow_up: false
    };
  }

  componentDidMount() {
    this.setState({ mounted: !this.state.mounted });
    this.getLatestReplies();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      // console.log('reloadReply', this.props.reloadReply);
      if (this.props.reloadReply === true && this.state.loadLatestReply === 1) {
        this.setState({ loadLatestReply: 2 });
        this.getLatestReplies();
        this.props.setReloadReply(false);
      }
    }
  }

  changeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  changeHandler2 = (e) => {
    let query = '';
    if (e) {
      this.setState({ query: e.value })
      query = e.value;
    } else {
      this.setState({ query: '' })
    }
    this.search(query);
  };

  onChangeDateRange = (daterange) => {
    if (daterange) {
      this.setState({ loading: true, activePage: 1, daterange })
      this.getLatestReplies(1, daterange)
    }
  }

  handleTabChange = (tabName) => {
      this.setState({activeTab:tabName});
  }

  getLatestReplies = (pageNumber = null, daterange = null, query = this.state.query, followUp = this.state.follow_up) => {
    let date = (daterange) ? daterange : this.state.daterange;
    let new_daterange = moment(date[0]).format("YYYY-MM-DD") + "," + moment(date[1]).format("YYYY-MM-DD");
    let data = {
      query: query,
      page: (pageNumber) ? pageNumber : this.state.activePage,
      daterange: new_daterange,
      follow_up: followUp
    }
    AJAX_REQUEST("POST", "operator/latest_replies_react", data).then((results) => {

      // Sentry Log create
      sentryErrorLog(results);

      if (parseInt(results.response.code) === 1000) {
        const data = results.response.data;

        this.setState({
          loading: false,
          loadLatestReply: 1,
          latest_replies: data.last_replies ? data.last_replies : [],
          latest_reply_info: data.latest_reply_info,
          itemsCountPerPage: data.per_page,
          totalItemsCount: data.total_messages,
          errorMsg: ''
        });
      } else {
        this.setState({
          loading: false,
          latest_replies: [],
          errorMsg: results.response.message
        });
      }
    });
  };

  paginationLatestReply = (pageNumber) => {
    this.setState({ loading: true, activePage: pageNumber })
    this.getLatestReplies(pageNumber)
  };

  search = (query) => {
    if (query === '' || query.length >= 3) {
      this.setState({ loading: true, activePage: 1 })
      this.getLatestReplies(1, null, query)
    }
  };

  showOption = (value) => {
    if (value.length >= 3) {
      let date = this.state.daterange;
      let follow_up = this.state.follow_up;
      let new_daterange = moment(date[0]).format("YYYY-MM-DD") + "," + moment(date[1]).format("YYYY-MM-DD");
      AJAX_REQUEST("POST", "operator/latest_replies_search", { query: value, daterange: new_daterange, follow_up: follow_up}).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          this.setState({ Options: results.response.data.last_replies })
        } else {

        }
      });
      this.setState({ option_true: true })
    } else {
      this.setState({ option_true: false })
    }
  }

  handleFollowUp = (follow_up_state) => {
    let daterange = follow_up_state ? [new Date(moment().subtract(30, "months")), new Date()] : null
    this.setState({ follow_up: follow_up_state, loading: true })
    this.getLatestReplies(null, daterange, null, follow_up_state)
  }


  render() {

    return (
      <div className="customer-lis-wrapper">
        <div className="customer-list">

          <div className="customer-sms-list">
            <div className="latest-replies-wrapper">
              <div className="latest-replies-header">
                <div className="latest-replies-header-title">Replies</div>
                <div className="follow-up-latest-replies"><button id={this.state.follow_up ?  "unfollow-up-button" : "follow-up-button"} onClick={ () => {
                  this.handleFollowUp(!this.state.follow_up)
                }  
                  }>{this.state.follow_up ?  "Unsnooze" : "Snooze"}</button></div>
                <div className="latest-replies-header-pagination">
                  <span> {this.state.latest_reply_info} </span>
                  <div className="schedule-message">
                    <Pagination
                      activePage={this.state.activePage}
                      itemsCountPerPage={this.state.itemsCountPerPage}
                      totalItemsCount={this.state.totalItemsCount}
                      pageRangeDisplayed={1}
                      onChange={(pageNumber) => this.paginationLatestReply(pageNumber)}
                      prevPageText={<PaginationLeftButton />}
                      nextPageText={<PaginationRightButton />}
                      hideFirstLastPages={true}
                    />
                  </div>
                </div>
              </div>

              <div className="latest-replies-list latest-replies-list-search-wrapper">

                <div className="searhFieldWrapper">

                  <Select
                    isClearable
                    options={this.state.option_true ? this.state.Options : []}
                    onInputChange={this.showOption}
                    noOptionsMessage={() => null}
                    placeholder="Search"
                    classNamePrefix='Select'
                    className="selectSearch"
                    onChange={this.changeHandler2} name="query" />
                </div>

                <div className="DateRangePickerContainer">
                  <DateRangePicker
                    className="form-control0"
                    clearIcon={false}
                    onChange={this.onChangeDateRange}
                    value={this.state.daterange}
                    rangeDivider="-"
                    format="MM/d/y"
                  />
                </div>

                {this.state.loading ? (
                  <div className="loading">
                    <FontAwesomeIcon icon={faIcon.faSyncAlt} />
                  </div>
                ) : (
                  <Fragment>
                    {this.state.latest_replies.length > 0 ? (
                      <Scrollbars
                        renderTrackVertical={(props) => <div {...props} className="track-vertical" />}
                        renderThumbVertical={(props) => <div {...props} className="thumb-vertical" />}
                        className="fullLatestList"
                        ref={this.messageScrollbars}
                        onScrollStop={this.handleScrollStop}
                        id="fullLatestList_scrollbar"
                      >
                        <RBT.ListGroup className="">
                          {this.state.latest_replies.map((latest_replies_single, index) => {
                            let autoAssignedClass = this.props.isAutoAssigned ? ' LiveActive' : '';
                            return (
                              <RBT.ListGroup.Item
                                key={"latestreply" + latest_replies_single.contact_id}
                                onClick={() =>
                                  this.props.settLeadFromLatestReplies(
                                    latest_replies_single.contact_id,
                                    latest_replies_single.user_id
                                  )
                                }
                                id={
                                  "triggerid_" + latest_replies_single.contact_id + "_" + latest_replies_single.user_id
                                }
                                className={((latest_replies_single.contact_id === this.props.current_contact) && (latest_replies_single.user_id === this.props.current_gym_owner) ? 'active' + autoAssignedClass : '')}
                              >
                                <div className="latest-replies-name">
                                  <RBT.Nav.Link href="#" title={latest_replies_single.user_name}> {latest_replies_single.user_name}</RBT.Nav.Link>
                                </div>
                                <div className="latest-replies-left">
                                  <h3>
                                    <RBT.Nav.Link href="#" title={latest_replies_single.contact_name}>{latest_replies_single.contact_name}</RBT.Nav.Link>
                                  </h3>
                                  <div className="chat-count-time">

                                    <span>
                                      <FontAwesomeIcon icon={faIcon.faComments} />
                                      {latest_replies_single.total_sms}
                                    </span>
                                    <span>
                                      <FontAwesomeIcon icon={faIcon.faClock} />
                                      {latest_replies_single.updated_time}
                                    </span>
                                  </div>
                                </div>
                              </RBT.ListGroup.Item>
                            );
                          })}
                        </RBT.ListGroup>
                      </Scrollbars>
                    ) : (
                      <div className="server-error-message">{this.state.errorMsg}</div>
                    )}
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="lco-corner-box">
          <div className="lco-corner-tabs">
            <button onClick={() => this.handleTabChange('stats')} data-type="Stats" className={this.state.activeTab === 'stats' ? 'active' : ''}>Stats</button>
            <button onClick={() => this.handleTabChange('notes')} data-type="Notes" className={this.state.activeTab === 'notes' ? 'active' : ''}>Internal Notes</button>
          </div>
          <div className="frame-container">
            {this.state.activeTab === 'notes' && (
            <iframe
            src={`${APP_URL}internal-notes/${this.props.current_gym_owner || ''}`}
            title="Business Internal Notes"
            />)}
          </div>
          <div className="frame-container">
            {this.state.activeTab === 'stats' && (
            <iframe
            src={`${APP_URL}internal-notes/stats/${this.props.lco_id}`}
            title="Business Internal Notes"
            />)}
          </div>
        </div>
      </div>
    );
  }
}

ContactList.propTypes = {
  setReloadReply: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    reloadReply: state.auth.reloadReply,
  };
}
export default connect(mapStateToProps, { setReloadReply })(ContactList);